import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=ac3a4c1c&scoped=true&"
import script from "./Tile.vue?vue&type=script&lang=ts&"
export * from "./Tile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3a4c1c",
  null
  
)

export default component.exports